import { captureException, captureMessage } from '@sentry/nextjs';

const useErrorLogging = () => {
  const logError = (type, error, tags) => {
    console.error(`${type}: `, error);
    if (error instanceof Error) {
      captureException(error, {tags: {...tags, type: type}});
    } else {
      captureMessage(`${type}: ${error}`, {tags: {...tags, type: type}});
    }
  };

  return logError
}

export default useErrorLogging
